import { toDatetimeLocalInputValue } from "@/vnext/routes/support/live-alerts/liveAlertDetailDrawerModel";
import { formatCrmDateTimeNz } from "@/vnext/shared/crmDateFormatters";
export const CONTACT_NEXT_ACTION_TIME_ZONE = "Pacific/Auckland";
const formatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: CONTACT_NEXT_ACTION_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});
const parts = (date: Date) => {
  const values = formatter.formatToParts(date);
  const part = (key: Intl.DateTimeFormatPartTypes) =>
    Number(values.find((value) => value.type === key)?.value);
  return {
    year: part("year"),
    month: part("month"),
    day: part("day"),
    hour: part("hour"),
    minute: part("minute"),
  };
};

/** Next NZ weekday at 09:00. No holiday calendar is available in this surface. */
export const suggestContactNextActionTime = (
  now: Date = new Date(),
): { iso: string; localInput: string } | null => {
  if (!Number.isFinite(now.getTime())) return null;
  const today = parts(now);
  const calendar = new Date(
    Date.UTC(today.year, today.month - 1, today.day + 1, 9),
  );
  while ([0, 6].includes(calendar.getUTCDay()))
    calendar.setUTCDate(calendar.getUTCDate() + 1);
  return localCalendarTime(calendar);
};

/** Thirty NZ calendar days, including weekends; 09:00 avoids DST gaps. */
export const suggestThirtyDayContactReminder = (
  now: Date = new Date(),
): { iso: string; localInput: string } | null => {
  if (!Number.isFinite(now.getTime())) return null;
  const today = parts(now);
  return localCalendarTime(
    new Date(Date.UTC(today.year, today.month - 1, today.day + 30, 9)),
  );
};
const localCalendarTime = (
  calendar: Date,
): { iso: string; localInput: string } => {
  // 09:00 is outside NZ's DST transition gap/overlap. Resolve the selected
  // wall clock with Intl rather than adding 24h across an offset change.
  const wall = calendar.getTime();
  let instant = wall;
  for (let pass = 0; pass < 3; pass++) {
    const actual = parts(new Date(instant));
    const delta =
      wall -
      Date.UTC(
        actual.year,
        actual.month - 1,
        actual.day,
        actual.hour,
        actual.minute,
      );
    instant += delta;
    if (delta === 0) break;
  }
  const iso = new Date(instant).toISOString();
  return { iso, localInput: toDatetimeLocalInputValue(iso) };
};
export const formatContactNextActionTime = (value: string): string =>
  `${formatCrmDateTimeNz(value)} (New Zealand time)`;
